<template>
  <div>
    <!--Toolbar-->
    <tool-bar title="OT Service Logs"></tool-bar>
    <v-container
      v-if="appReady"
      grid-list-xl
      class="page-container"
      :class="{ 'py-4': !isMobile, 'mobile': isMobile }">
      <v-layout row wrap>
        <v-flex xs12 sm6 :class="{'pb-0': isMobile}">
          <select-students></select-students>
        </v-flex>
        <v-flex xs12 sm6 :class="{'pt-0': isMobile}">
          <v-btn
            class="main-action-button active"
            @click="goToSearch"
            block>
            <v-icon class="pr-3">
              search
            </v-icon>
            Search Service Logs
          </v-btn>
        </v-flex>
        <v-flex xs12 class="mt-3 mb-5">
          <div v-if="submissionArray && submissionArray.length">
            <div class="title font-bold mb-3">
              Recent Service Logs
            </div>
            <v-expansion-panel id="expansion" class="service-log-expansion">
              <v-expansion-panel-content
                v-for="(submission, index) in submissionArray"
                :key="index">
                <div slot="header">
                  <strong>{{ submission.date | formatDate }}</strong>
                  ({{ submission.logs.length }})
                </div>
                <div v-for="(log, i) in submission.logs" :key="i">
                  <v-container
                    :class="{ 'not-last': i !== submission.logs.length - 1 }"
                    class="px-4 py-3 submission-container"
                    @click="showConfirmation(log)">
                    <v-layout
                      row wrap
                      :class="{'xs-font': isMobile, 'sm-up-font': !isMobile}">
                      <v-flex
                        xs12 sm6 md4
                        :class="{'pb-0': isMobile}"
                        style="display: grid">
                        <div class="primary--text">
                          <strong>
                            {{ log.studentFirstName }} {{ log.studentLastName }}
                            ({{ log.studentExtId }})
                          </strong>
                        </div>
                        <div>{{ log.studentSchoolName }} ({{ log.grade }})</div>
                        <div v-if="isAbsent(log.absentType)"
                          style="color: red; font-weight: bold;">
                            ABSENT
                        </div>
                        <div v-else>
                          {{ log.sessionTime | militaryTimeToStandard }}
                          <span v-if="log.sessionMinutes">
                            ({{ log.sessionMinutes }} mins)
                          </span>
                        </div>
                        <div>
                          {{ log.deliveryMode }}
                        </div>
                        <div>
                          {{ log.roomName }}
                        </div>
                        <div>
                          {{ log.notes }}
                        </div>
                      </v-flex>
                      <!---->
                      <v-flex
                        xs12 sm6 md4
                        :class="{'pt-0': isMobile}">
                        <br/>
                        <div>{{ `${log.planTypeName}: ${log.serviceType}` }}</div>
                        <div>
                          {{ log.serviceStartDate | formatDate }} -
                          {{ log.serviceEndDate | formatDate }}
                        </div>
                        <div>
                          {{ log.providerFirstName + ' ' + log.providerLastName }}
                          <span v-if="log.providerCredential">
                            / {{ log.providerCredential }}
                          </span>
                          <span v-if="log.supervisorFlag">
                              <v-icon
                                size="small"
                                color="green">mdi-checkbox-marked-circle
                              </v-icon>
                          </span>
                        </div>
                      </v-flex>
                      <v-flex xs12 md4>
                        <action-icons
                          :fromDashboard="true"
                          v-on:service-log:deleted="loadDashboard"
                          :submission="log">
                        </action-icons>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <!--confirmation modal-->
    <div v-if="confirmationDialog">
      <submission-history
        :submission="confirmationDialog"
        :fromDashboard="true"
        v-on:reload:page="loadDashboard"
        v-on:dialog:closed="historyDialogClosed">
      </submission-history>
    </div>
    <bottom-nav></bottom-nav>
    <full-screen-loading-spinner v-if="showLoading"></full-screen-loading-spinner>
  </div>
</template>

<script>
import api from '@/utils/api';
import Toolbar from '@/components/toolbar';
import SelectStudents from '@/components/select-student-dialog';
import FullScreenLoadingSpinner from '@/components/full-screen-loading-spinner';
import ActionIcons from '@/components/action-icons';
import SubmissionHistory from '@/components/service-log/history/submission-history-dialog';
import utilityFunctions from '@/utils/functions';
import BottomNav from '@/components/bottom-nav';
import * as Constants from '@/constants';

export default {
  components: {
    Toolbar,
    SelectStudents,
    FullScreenLoadingSpinner,
    ActionIcons,
    SubmissionHistory,
    BottomNav
  },
  name: 'DashboardView',
  data() {
    return {
      provider: '',
      submissionArray: null,
      appReady: false,
      showLoading: false,
      confirmationDialog: false
    };
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    },
    isTablet() {
      return this.$mq === 'tablet';
    }
  },
  methods: {
    goToSearch() {
      this.$router.push('/search');
    },
    loadDashboard() {
      this.showLoading = true;
      api.get(Constants.OTSL_DASHBOARD_LISTING_URL(5))
        .then((res) => {
          this.appReady = true;
          this.showLoading = false;
          this.submissionArray = res.data.data;
        })
        .catch((error) => {
          this.errorMsg = error.message;
          this.showLoading = false;
        });
    },
    serviceLogDeleted() {
      this.loadDashboard();
    },
    showConfirmation(log) {
      this.confirmationDialog = log;
    },
    historyDialogClosed() {
      this.confirmationDialog = false;
      this.loadDashboard();
    },
    isAbsent(absentType) {
      return Constants.IS_ABSENT(absentType);
    }
  },
  created() {
    utilityFunctions.clearSubmissionArray();
    this.showLoading = true;
    this.loadDashboard();
  }
};
</script>

<style lang="scss" scoped>
  .service-log-expansion {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    .v-expansion-panel__container {
      /deep/ .v-expansion-panel__header {
        color: var(--v-primary-base);
        &:hover {
          background-color: rgba(0, 0, 0, 0.04);
        }
      }
      .submission-container {
        cursor: pointer;
        &:hover {
          background-color: rgba(0, 0, 0, 0.04);
        }
      }
      .not-last {
        border-bottom: 1px solid var(--v-primary-base);
      }
    }
    .v-expansion-panel__container:first-child {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      /deep/ .v-expansion-panel__header {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }
    }
    .v-expansion-panel__container:last-child {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    .v-expansion-panel__container--active {
      /deep/ .v-expansion-panel__header {
        background-color: var(--v-primary-base);
        color: #fff;
        &:hover {
          background-color: var(--v-primary-base);
        }
        .v-expansion-panel__header__icon i {
          color: #fff !important;
        }
      }
    }
  }

  .xs-font {
    font-size: 13px;
  }

  .sm-up-font {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard.vue